const dayjs = require("dayjs");

function dateFormatShort(date) {
  try {
    return dayjs(date).format("YYYY-MM-DD");
  } catch (error) {
    console.error("Error formatting date:", error);
    return date; // Return the original date if formatting fails
  }
}
module.exports = dateFormatShort;
